import ContactIdMappingListModelBase from '../_generated/modelBases/contact-id-mapping-list-model-base';

export default class ContactIdMappingListModel extends ContactIdMappingListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
